import React from 'react'
import { reduxForm, Field } from 'redux-form'
import PropTypes from 'prop-types'

import {
  formContainer,
  titleContainer,
  mainTitle,
  buttonContainer
} from './styles/LoginForm.style'

import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'

import * as validators from '../../utils/validators'

const LoginForm = ({ handleSubmit, onSubmit, emailValue, translation, lang }) => {
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const email = lang === 'pt-BR' ? validators.emailPT : validators.emailES
  return (
    <form className={formContainer} onSubmit={handleSubmit(onSubmit)}>
      <header className={titleContainer}>
        <h1 className={mainTitle}>{translation('changeEmailForm')['emailFormTitle']}</h1>
      </header>

      <div>
        <Field
          name='email'
          placeholder={translation('changeEmailForm')['emailPlaceholder']}
          type='text'
          block
          validate={[required, email]}
          component={Input}
          props={{ value: emailValue }}
        />
      </div>

      <div className={buttonContainer}>
        <Button
          type='submit'
        >
          {translation('changeEmailForm')['changeButton']}
        </Button>
      </div>
    </form>
  )
}
LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  emailValue: PropTypes.string,
  translation: PropTypes.func,
  lang: PropTypes.string
}

export default reduxForm({
  form: 'changeEmail'
})(LoginForm)
